const vehicleTypes = {
    '1': 'Automatic',
    '2': 'Manual'
}

export default vehicleTypes